import React from 'react';
import get_bundle from '../domain/get_bundle';
import Locale from '../domain/Locale';
import Product from '../domain/Product';
import { props } from 'tcomb-react';
import StdTable from './StdTable';
import template from 'lodash/string/template';


@props({
  locale: Locale,
  product: Product
})
export default class ProductConditions extends React.Component {

  getDisplayShippingCountries() {
    return this.props.product.shipping_countries().map(c => this.props.locale.display_country(c)).join(', ');
  }

  getRows() {
    const {locale, product} = this.props;
    const bundle = get_bundle(locale).product.product.conditions;

    return [
      [
        bundle.end_date,
        template(bundle.end_date_value)({
          date: locale.format_date(product.end_date)
        })
      ],
      [
        bundle.nr_items,
        locale.format_integer(product.nr_items)
      ],
      [
        bundle.max_items,
        locale.format_integer(product.max_items)
      ],
      [
        bundle.min_price,
        product.is_min_price_hidden ? null : product.format_amount(locale, product.min_price)
      ],
      [
        bundle.countries,
        !(product.is_coupon) ? this.getDisplayShippingCountries() : null
      ],
      [
        bundle.gift_card,
        product.gift_card_not_supported ? " " : null
      ],
      [
        bundle.bonus,
        product.bonus_not_supported ? " " : null
      ]
    ];
  }

  render() {
    return <StdTable>{this.getRows()}</StdTable>;
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/ProductConditions.js
 **/